<template>
  <div class="map-page">
    <div class="bg-layer" />

    <div style="width: 1120px;margin: 0 auto;z-index: 1;position: relative;">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>NQI站点</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="content-container"  @click="onPageClick">
      <div class="map-section" ref="mapRef">
        <img
          ref="mapImg"
          src="../../assets/img/NQR/index_bg.png"
          usemap="#zibo-map"
          class="zibo-map"
          alt="淄博市地图"
        >

        <map name="zibo-map">
          <area 
            href="javascript:;" 
            coords="33,15,47,22,71,23,94,1,113,9,127,-1,135,7,146,5,151,13,144,25,162,29,165,21,171,29,179,28,185,35,181,41,179,48,183,57,185,67,177,74,155,90,125,102,92,100,69,108,50,107,29,101,15,103,9,95,3,79" 
            shape="poly"
            @click="showAreaInfo('高青县', '10', $event)"
          />
          <area 
            href="javascript:;"
            coords="113,103,141,96,160,86,177,76,187,85,203,74,209,78,209,87,218,86,217,95,214,108,225,124,233,122,235,127,233,139,235,145,229,152,226,157,229,167,235,160,221,167,212,169,200,176,195,161,180,163,171,168,169,175,169,184,152,177,161,164,140,148,137,137,122,133,121,120,107,117" 
            shape="poly"
            @click="showAreaInfo('桓台县', '8', $event)"
          />
          <area
            shape="poly"
            coords="169,167,176,163,183,159,189,161,195,163,197,170,207,173,215,170,222,167,234,167,245,175,251,185,244,191,233,199,223,205,214,213,211,202,201,196,188,197,185,185,177,180"
            href="javascript:;"
            @click="showAreaInfo('高新区', '6', $event)"
          />
          <area
            shape="poly"
            coords="171,215,175,218,182,215,187,215,191,219,199,219,205,226,212,218,235,221,240,239,232,247,218,245,209,252,199,245,190,251,186,239,173,235"
            href="javascript:;"
            @click="showAreaInfo('经开区', '7', $event)"
          />
          <area
            shape="poly"
            coords="158,179,157,191,156,203,161,208,157,213,166,220,175,217,186,215,191,221,199,219,207,223,211,217,233,221,241,221,243,211,235,199,226,208,217,215,213,203,203,199,191,195,184,189,178,179,168,183"
            href="javascript:;"
            @click="showAreaInfo('张店区', '1', $event)"
          />
          <area
            shape="poly"
            coords="237,127,241,131,247,127,251,119,257,111,267,109,273,124,281,120,289,125,295,117,306,119,307,126,344,127,349,139,339,142,345,153,341,161,346,167,334,169,333,179,330,191,319,199,310,205,302,211,285,210,287,217,277,225,285,233,271,235,263,237,269,247,271,261,261,275,252,267,244,269,227,255,229,243,242,239,235,225,245,220,243,213,237,199,253,186,247,177,241,171,230,158,233,148,235,138"
            href="javascript:;"
            @click="showAreaInfo('临淄区', '3', $event)"
          />
          <area 
            href="javascript:;"
            coords="152,174,147,179,145,187,136,187,138,189,129,193,117,197,116,213,116,224,120,232,125,233,128,241,118,241,118,251,112,261,105,267,96,269,85,275,80,284,85,293,96,293,107,285,111,290,120,288,134,291,147,292,142,269,152,270,162,263,168,259,162,251,164,238,174,236,171,226,172,215,163,221,159,213,158,208,157,201,160,191"
            shape="poly"
            @click="showAreaInfo('周村区', '5', $event)"
          />
          <area
            shape="poly"
            coords="139,267,148,269,155,265,167,261,167,253,162,241,174,236,181,235,182,243,186,247,195,243,203,249,216,245,229,250,235,261,243,270,250,267,259,275,263,281,267,287,257,297,253,309,261,316,275,321,271,334,275,344,283,353,281,362,284,377,292,379,284,387,275,395,274,385,263,389,256,379,244,394,239,382,237,372,223,365,213,371,205,373,195,369,187,363,179,361,171,353,165,350,180,343,170,330,162,325,155,317,142,317,136,313,130,318,127,327,120,329,113,324,103,329,95,335,84,329,92,327,90,319,81,317,93,312,89,303,85,295,98,287,113,285,130,293,144,286"
            href="javascript:;"
            @click="showAreaInfo('淄川区', '2', $event)"
          />
          <area
            shape="poly"
            coords="96,335,101,329,110,325,117,330,125,326,129,317,137,313,145,315,155,317,159,323,166,330,176,336,172,346,160,350,170,356,174,363,183,361,191,365,197,370,210,373,220,368,234,369,236,381,240,391,254,385,257,379,263,389,273,387,275,394,281,397,284,404,276,407,271,418,274,430,266,434,251,440,243,439,229,437,220,437,212,445,203,448,201,455,184,454,184,442,180,433,185,421,173,419,168,426,166,415,155,405,150,395,142,391,137,383,127,391,113,388,118,378,114,374,113,367,107,361,116,357"
            href="javascript:;"
            @click="showAreaInfo('博山区', '4', $event)"
          />
          <area
            shape="poly"
            coords="201,455,203,447,209,444,218,437,232,436,241,436,250,438,260,433,274,431,270,415,277,412,286,401,281,389,287,387,300,404,317,405,312,414,321,423,321,435,324,441,336,439,355,443,351,455,352,465,363,478,363,493,373,495,380,489,393,493,394,506,399,517,406,520,411,533,398,538,399,546,404,555,410,565,393,573,383,567,377,557,364,559,367,569,356,574,346,581,337,580,333,589,320,593,315,583,308,586,299,577,306,572,293,561,279,555,260,559,249,567,246,578,236,587,238,595,228,596,228,585,212,597,205,582,210,573,206,557,197,549,206,542,205,532,198,535,192,523,186,508,181,497,188,487,201,480"
            href="javascript:;"
            @click="showAreaInfo('沂源县', '9', $event)"
          />
        </map>

        <div
          v-if="showPopup"
          class="map-popup"
          :style="{ left: `${popupX}px`, top: `${popupY}px` }"
          @click.stop="jumpAct(region)"
        >
        <div style="position: absolute;top: 10px; right: 10px;font-size: 14px;cursor: pointer;" @click.stop="onPageClick">X</div>
          <div class="popup-title" style="padding-top: 10px;">{{ currentName }}</div>
          <div class="popup-content" v-for="value in regionServiceList">{{ value.name }}</div>
          <div class="popup-arrow" />
        </div>
      </div>

      <div class="list-section" @click="jumpAct()">
        <div class="list-card">
          <div
            class="list-item"
            v-for="(item, index) in serviceList"
            :key="index"
          >
            {{ item.name }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Server, httpurl } from '@/server';
export default {
  name: 'MapServicePage',
  data() {
    return {
      showPopup: false,
      popupX: 0,
      popupY: 0,
      currentName: '',
      currentDesc: '',
      lastArea: null,

      serviceList: [],
      regionServiceList: [],

      region:''
    }
  },
  mounted() {
    this.getNQIQYList()
  },
  methods: {
    getNQIQYList() {
        Server.getNQIQYList({pageSize:-1}).then(res => {
            if (res.success) {
                console.log(res);
                this.serviceList = res.result.records
            }
        })
    },
    // ✅ 正确：弹框在鼠标点击位置 正下方
    async showAreaInfo(name, desc, e) {
       this.region = desc
       let result = await Server.getNQIQYList({region:desc,pageSize:-1})
       this.regionServiceList = result.result.records
       
      e.stopPropagation()
      this.currentName = name
      this.currentDesc = desc

      const mapEl = this.$refs.mapRef
      const rect = mapEl.getBoundingClientRect()

      // 正确定位：鼠标点击处 正下方弹出
      this.popupX = e.clientX - rect.left - 175
      this.popupY = e.clientY - rect.top + 10
      this.showPopup = true

      if (this.lastArea) {
        this.lastArea.style.background = "transparent"
      }
      e.target.style.background = "rgba(43, 125, 233, 0.3)"
      this.lastArea = e.target
    },

    // 点击空白关闭
    onPageClick() {
      this.showPopup = false
      if (this.lastArea) {
        this.lastArea.style.background = "transparent"
        this.lastArea = null
      }
    },
    jumpAct(region) {
        this.$router.push({
            path: '/NQIDetail',
            query: {
                region:region,
                name:this.currentName
            }
        })
    }
  },
}
</script>

<style scoped>
.map-page {
  width: 100%;
  min-height: 100vh;
  position: relative;
}

.bg-layer {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: url("../../assets/img/NQR/layer_bg.png") no-repeat center top;
  background-size: cover;
  z-index: 0;
}

.content-container {
  position: relative;
  z-index: 1;
  max-width: 1120px;
  margin: 0 auto;
  padding: 40px 20px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 30px;
}

.map-section {
  position: relative;
}
.zibo-map {
  width: 100%;
  height: auto;
  display: block;
}

/* 右侧列表 */
.list-section {
  width: 45%;
  margin-left: 70px;
}
.list-card {
  background: #ffffff;
  border-radius: 10px;
  padding: 5px 24px;
  height: auto;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
}
.list-item {
  font-size: 14px;
  color: #333;
  line-height: 1.6;
  padding: 7px 0;
  border-bottom: 1px solid #f2f2f2;
}
.list-item:last-child {
  border-bottom: none;
}

/* 弹框样式 */
.map-popup {
  position: absolute;
  width: 350px;
  background: #fff;
  border-radius: 6px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.15);
  padding: 12px 16px;
  z-index: 999;

  display: flex;
  flex-direction: column;
  justify-content: left;
  align-items: flex-start;
}
.popup-title {
  font-size: 14px;
  font-weight: bold;
  color: #2b7de9;
  margin-bottom: 6px;
  text-align: center;

  width: 100%;
}
.popup-content {
  font-size: 12px;
  color: #666;
  line-height: 1.5;
  text-align: center;
}
.service-card {
  display: flex;
  align-items: flex-start;
  padding: 20px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.1);
  gap: 16px;
}

.card-icon {
  width: 20px;
  height: 20px;
  flex-shrink: 0;
  margin-top: 4px;
}

.card-content {
  flex: 1;
  min-width: 0; /* 必须加，否则省略不生效 */
}

.card-title-row {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
}

.card-title {
  margin: 0;
  font-size: 15px;
  font-weight: bold;
  color: #222;
}

.entity-tag {
  background: #e0edff;
  color: #4080ff;
  font-size: 13px;
  padding: 4px 12px;
  border-radius: 6px;
}

.card-row {
  margin: 8px 0;
  font-size: 13px;
  display: flex;
  align-items: center;
}

.label {
  color: #333;
  white-space: nowrap;
}

/* ✅ 正确的单行省略 */
.value {
  color: #333;
  flex: 1;
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.card-info-row {
  display: flex;
  gap: 60px;
  margin-top: 16px;
  font-size: 12px;
  color: #666;
}

.info-item {
  display: flex;
  align-items: center;
  gap: 8px;
}

.info-icon {
  width: 18px;
  height: 18px;
  color: #666;
}
.popup-arrow {
  position: absolute;
  top: -6px;
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-bottom: 6px solid #fff;
}
</style>